import { render, staticRenderFns } from "./MainPublic.vue?vue&type=template&id=d9abd2d8&scoped=true&"
import script from "./MainPublic.vue?vue&type=script&lang=ts&"
export * from "./MainPublic.vue?vue&type=script&lang=ts&"
import style0 from "./MainPublic.vue?vue&type=style&index=0&id=d9abd2d8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9abd2d8",
  null
  
)

export default component.exports